<template>
    <TsSection append-class="bg-idle-white">
        <TsBreadcrumb :data="breadcrumb_links" dataTestid="pro-card-breadcrumb" />
        <TsRow appendClass="p-0 pl-2 pb-5 pt-2">
            <TsTitle :title="useTranslation('applyForProCard' , 'Vraag een PRO-kaart aan')"/>
        </TsRow>
        <slot name="proCardForm"></slot>

        <TsHiFiveSection v-if="!isMobile" appendClass="mb-8" />

    </TsSection>
</template>

<script setup lang="ts">

const TsBreadcrumb = defineAsyncComponent(
    () => import('~/components/molecules/TsBreadcrumb.vue')
);

const TsHiFiveSection = defineAsyncComponent(
    () => import('~/components/organisms/TsHiFiveSection.vue')
);

const { isMobile } = useDevice();

const breadcrumb_links = [
    {
        text: useTranslation('home' , 'Thuis'),
        link: '/'
    }, {
        text: useTranslation('proCard' , 'Pro-kaart'),
        link: getContentSlug('pro')
    }, {
        text: useTranslation('applyPro-Card' , 'Pro-kaart aanvragen'),
        link: '/pro-card/application'
    }
];
</script>